module.exports = __webpack_public_path__ + "static/img/rz-n.3fbf855c.png";